export const LIMIT_PER_PERSON_DEFAULT = 0;
export const QUANTITY_LIMIT_DEFAULT = 0;
export const REDEEMABLE_PERIOD_DEFAULT = 60;